import { useState } from "react";
import { Link } from "react-router-dom";
import authApi from "../api/authApi";

export default function RegisterPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  async function handleRegister(e) {
    e.preventDefault();
    try {
      // TODO: call API register
      const param = {
        "fullName": name,
        "email": email,
        "password": password
      }
      await authApi.register(param);
      alert("Đăng kí thành công");
      window.location.href = "/login";
    } catch {
      alert("Có lỗi xảy ra");
    }
  }

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="card shadow-sm p-4" style={{ width: "380px", borderRadius: "12px" }}>
        <h3 className="text-center mb-3">Đăng ký</h3>

        <form onSubmit={handleRegister}>
          <div className="mb-3">
            <label>Họ tên</label>
            <input
              className="form-control"
              placeholder="Nhập họ tên"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label>Email</label>
            <input
              className="form-control"
              placeholder="Nhập email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-3">
            <label>Mật khẩu</label>
            <input
              className="form-control"
              placeholder="Tạo mật khẩu"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className="btn btn-success w-100">Tạo tài khoản</button>

          <div className="text-center mt-3">
            <Link to="/login" className="text-decoration-none">
              Đã có tài khoản? Đăng nhập
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
